import {
  DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_BEGIN,
  DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_SUCCESS,
  DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_FAILURE,
  DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function collectionListExternaldbs(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_BEGIN,
    });
    const { projectId, version, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/collection-externaldb/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCollectionListExternaldbsError() {
  return {
    type: DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_BEGIN:
      return {
        ...state,
        collectionListExternaldbsPending: true,
        collectionListExternaldbsError: null,
      };

    case DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_SUCCESS:
      return {
        ...state,
        collectionListExternaldbsPending: false,
        collectionListExternaldbsError: null,
        collectionList: action.data,
      };

    case DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_FAILURE:
      return {
        ...state,
        collectionListExternaldbsPending: false,
        collectionListExternaldbsError: action.data.error,
      };

    case DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_DISMISS_ERROR:
      return {
        ...state,
        collectionListExternaldbsError: null,
      };

    default:
      return state;
  }
}
